// extracted by css-extract-rspack-plugin
export default {"trigger":"src-modules-auth-templates-AuthPageTemplate-AuthLanguageSelector-AuthLanguageSelector-module__trigger-wYb5Je","inline":"src-modules-auth-templates-AuthPageTemplate-AuthLanguageSelector-AuthLanguageSelector-module__inline-dQiycI","flag":"src-modules-auth-templates-AuthPageTemplate-AuthLanguageSelector-AuthLanguageSelector-module__flag-Aw1BwZ","label":"src-modules-auth-templates-AuthPageTemplate-AuthLanguageSelector-AuthLanguageSelector-module__label-mplYS9","dropdown":"src-modules-auth-templates-AuthPageTemplate-AuthLanguageSelector-AuthLanguageSelector-module__dropdown-Bo8yHA"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"trigger\":\"src-modules-auth-templates-AuthPageTemplate-AuthLanguageSelector-AuthLanguageSelector-module__trigger-wYb5Je\",\"inline\":\"src-modules-auth-templates-AuthPageTemplate-AuthLanguageSelector-AuthLanguageSelector-module__inline-dQiycI\",\"flag\":\"src-modules-auth-templates-AuthPageTemplate-AuthLanguageSelector-AuthLanguageSelector-module__flag-Aw1BwZ\",\"label\":\"src-modules-auth-templates-AuthPageTemplate-AuthLanguageSelector-AuthLanguageSelector-module__label-mplYS9\",\"dropdown\":\"src-modules-auth-templates-AuthPageTemplate-AuthLanguageSelector-AuthLanguageSelector-module__dropdown-Bo8yHA\"}";
        // 1793874318062
        var cssReload = require("../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  